/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Bright_Elk_BiteInputs */

const en_thin_bright_elk_bite = /** @type {(inputs: Thin_Bright_Elk_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow comments for this segment`)
};

const de_thin_bright_elk_bite = /** @type {(inputs: Thin_Bright_Elk_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare für dieses Segment erlauben`)
};

/**
* | output |
* | --- |
* | "Allow comments for this segment" |
*
* @param {Thin_Bright_Elk_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_bright_elk_bite = /** @type {((inputs?: Thin_Bright_Elk_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Bright_Elk_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_bright_elk_bite(inputs)
	return de_thin_bright_elk_bite(inputs)
});